import React from "react";
import { Link } from "react-router-dom";

const ReturnAndExchangePolicy = () => {
  return (
    <div className="bg-white text-gray-800 font-sans">
      <div
        className="relative w-full h-[150px] sm:h-[200px] md:h-[250px] mb-3 bg-cover bg-center overflow-hidden"
        style={{
          backgroundImage: `url(${require("../../assets/images/home/img_bag.jpg")})`,
        }}
      >
        {/* Black overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center text-white text-center p-4">
          {/* Page Title */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl mb-2 tracking-wide">
            Return and Exchange Policy
          </h2>

          {/* Breadcrumb */}
          <nav className="flex items-center space-x-2 text-sm text-gray-200 bg-black/40 px-4 py-2 rounded-md max-w-fit mx-auto">
            <Link to="/" className="hover:text-white">
              Home
            </Link>
            <span>/</span>
            <span>Return & Exchange Policy</span>
          </nav>
        </div>
      </div>

      <div className=" mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-12 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Thank You for Shopping at Luggaelegacy
            </h2>
            <p>
              If, for any reason, you are not completely satisfied with a
              purchase, we invite you to review our policy. The following terms
              are applicable for any products that you purchased with us.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Interpretation and Definitions
            </h2>
            <h3 className="text-xl font-semibold mb-2 text-gray-800">
              Interpretation
            </h3>
            <p>
              The words of which the initial letter is capitalized have meanings
              defined under the following conditions. The following definitions
              shall have the same meaning regardless of whether they appear in
              singular or plural.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              General Return Policy
            </h2>
            <p>
              Products bought from the Physical Stores can’t be returned. All
              items bought online are eligible for return and would be processed
              if conditions are met.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Refund Policy
            </h2>
            <p className="mb-4">
              In order to be eligible for a refund, you have to return the
              product within **7 days** of your purchase. If the product is
              damaged in any way, or you have initiated the return after 7 days
              have passed, you will not be eligible for a refund.
            </p>
            <p className="mb-4">
              To ensure the product is eligible for a refund, the following
              conditions must be met:
            </p>
            <ul className="list-disc list-outside pl-5 space-y-2 mb-4">
              <li>Product must be in its original packaging and unused.</li>
              <li>Product must have the receipt or proof of purchase.</li>
              <li>
                If the product you have received turns out to be damaged, please
                notify us as soon as possible after becoming aware of the issue.
              </li>
            </ul>
            <p>
              After we receive your returned item, our team will inspect it and
              process your refund. The money will be refunded to the original
              payment method you’ve used during the purchase. For credit card
              payments it may take 5 to 10 business days for a refund to show up
              on your credit card statement.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Contact Us
            </h2>
            <p>
              If you have any questions about our Returns and Refunds Policy,
              please contact us:
            </p>
            <p className="mt-2">
              By email:{" "}
              <a
                href="mailto:support@galaxybag.com"
                className="text-black font-semibold hover:underline"
              >
                support@galaxybag.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ReturnAndExchangePolicy;
